import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {isMobile} from "react-device-detect";
import AdSense from 'react-adsense';
import queryString from 'query-string';
import SocketHandler from '../helpers/SocketHandler';
import {
    HeaderLayout,
} from '../components/layout'
import HeaderTop from '../components/Templates/HeaderTop';
import TrackItem from '../components/TrackItem'
import LoadingItem from '../components/LoadingItem'
import NumberBox from '../components/NumberBox'
import TrackIcon from '../components/TrackIcon'
import TranslationSelectorDialog from '../components/TranslationSelectorDialog'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import {
    changeViewPortWidth,
    changeTrackingNrArr
} from '../redux/Tracefully/AppSettings';
import {toaster} from "evergreen-ui";


const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        changeViewPortWidth: changeViewPortWidth,
        changeTrackingNrArr: changeTrackingNrArr,
       // showLoading: showLoading,
       // hideLoading: hideLoading
    }, dispatch)
};


const mapStateToProps = function (state) {
    return {
        AppSettings: state.AppSettings,
    }
};


class index extends React.Component {


    constructor(props) {
        super(props);

        // Don't call this.setState() here!
        this.interval = null;
        this._scrollBarRef = React.createRef();
        this.recaptcha = React.createRef();
        this.initialResult = this.initialResult.bind(this);
        this.processResult = this.processResult.bind(this);
        this.tracfullyConnection = new SocketHandler(this.initialResult, this.processResult);
        this.processingNrs=[]

        this.state = {
            trackArr: [],
            trackObjects: {},
            trackingNrArr: [],
            tryCoutner: 0,
            refreshCounter: 150,
            scroll: false,
            loading: false,
            processRunning:false,
        };
    }



    componentDidMount() {
        this.props.changeViewPortWidth({viewportWidth: window.innerWidth});

        let params;
        if(process.browser){
            params = queryString.parse(location.search);
        }

        if (process.browser && typeof params.tn != "undefined") {
            let tnrArr = params.tn.split(',');
            console.log('tn params:', tnrArr);
            if (tnrArr.length > 0 && params.tn != "") {

                let refArr = []
                for (let i = 0; i < tnrArr.length; i++) {
                    if (tnrArr[i] != "") {
                        refArr.push({tnr: tnrArr[i], ref: React.createRef()})
                    }
                }
                this.setState({trackingNrArr: tnrArr, loading:true,processRunning:true});
                this.track(tnrArr);
                this.props.changeTrackingNrArr(refArr)
            } else {
                this.setState({trackingNrArr: []});
                let refArr = []
                refArr.push({tnr: '', ref: React.createRef()})
                this.props.changeTrackingNrArr(refArr)
            }
        } else {
            this.props.changeTrackingNrArr([{tnr: '', ref: React.createRef()}])
        }

        window.addEventListener("resize", this.updateSize.bind(this));
        document.addEventListener("ps-scroll-y", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateSize.bind(this));
        document.removeEventListener("ps-scroll-y", this.handleScroll);
        clearInterval(this.interval);
        this.interval = null;
    }

    updateSize() {
        this.props.changeViewPortWidth({viewportWidth: window.innerWidth});
    }

    handleScroll=()=>{

        console.log('scroll');
        if (this._scrollBarRef.current._ps.scrollbarYTop > 5) {
            if (!this.state.scroll) {
                this.setState({scroll: true});
            }
        } else {
            if (this.state.scroll) {
                this.setState({scroll: false});
            }
        }

    }
    handleMobileScroll=()=>{

        if (this._scrollBarRef.current.scrollTop > 5) {
            if (!this.state.scroll) {
                this.setState({scroll: true});
            }
        } else {
            if (this.state.scroll) {
                this.setState({scroll: false});
            }
        }

    }


    initialResult(result) {
        console.log('initalResult', result);
        let tempTrackObj = {}
        for (let i = 0; i < result.data.length; i++) {
            tempTrackObj[result.data[i].trackingNr] = result.data[i];
        }
        if(result.trackingNrQueueArr){
            this.trackingNrQueueArr = result.trackingNrQueueArr
        }
        let processing =true;
        if(this.trackingNrQueueArr.length==0) processing = false;
        this.setState({trackObjects: tempTrackObj, loading:false,processRunning:processing});
    }

    processResult(data) {
        if (!this.ignoreUpdates) {
            let tempTrackObj = this.state.trackObjects;
            if (data && Array.isArray(data)) {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].trackingNr && tempTrackObj[data[i].trackingNr]) {
                        tempTrackObj[data[i].trackingNr] = data[i];
                        if(this.trackingNrQueueArr.includes(data[i].trackingNr)){
                            this.trackingNrQueueArr.splice(this.trackingNrQueueArr.indexOf(data[i].trackingNr),1);
                        }
                    }
                }
                let processing =true;
                if(this.trackingNrQueueArr.length==0) processing = false;
                this.setState({trackObjects: tempTrackObj,processRunning:processing});
            } else {
                if (data && data.trackingNr) {
                    tempTrackObj[data.trackingNr] = data;
                    if(this.trackingNrQueueArr.includes(data.trackingNr)){
                        this.trackingNrQueueArr.splice(this.trackingNrQueueArr.indexOf(data.trackingNr),1);
                    }
                    let processing =true;
                    if(this.trackingNrQueueArr.length==0) processing = false;
                    this.setState({trackObjects: tempTrackObj,processRunning:processing});
                }
            }
            console.log('processResult', data);
        }

    }

    async track(trackingNrArr) {

        try {
            console.log('track:', trackingNrArr);

            try {
                this.ignoreUpdates = false;
                this.tracfullyConnection.track(trackingNrArr)
            } catch (e) {
                console.log(e);
                toaster.danger('Failed to start update', {description: 'Please try it again in a few minutes.'})
                this.setState({loading: false,processRunning:false})
            }

        } catch (err) {
            this.setState({loading:false,processRunning:false})
        }
    }


    newTrack() {
        let filterArr = this.props.AppSettings.trackingNrArr.filter((item) => {
            if(item.tnr!=""){
                return true
            }else{
                return false;
            }
        })
        let newArr =[...new Set(filterArr.map(item => item.tnr))];
        let newRefArr=[]
        for(let i =0; i<newArr.length;i++){
            newRefArr.push({
                    tnr:newArr[i],
                    ref:React.createRef()
            })
        }

        if(newArr.length>0){
            this.props.changeTrackingNrArr(newRefArr)
            this.setState({trackingNrArr: newArr, loading: true,processRunning:true}, () => this.track(newArr))
            history.pushState({}, null, '?tn='+newArr.join(','));
        }else{
            toaster.danger('No tracking number entered',{description:'Enter your tracking number in the field bellow to start tracking.',duration:5})
        }

    }

    removeTnr(index) {
        console.log(this.state.trackingNrArr);
        console.log('delete', index);
        if (this.state.trackingNrArr[index]) {
            let temp = this.state.trackingNrArr;
            let tempTrackObj = this.state.trackObjects;
            let tempQueue = this.state.trackingNrQueueArr;
            tempQueue = tempQueue.filter(e=> e !== this.state.trackingNrArr[index]);
            console.log('delete');
            if (tempTrackObj[this.state.trackingNrArr[index]]) {
                delete tempTrackObj[this.state.trackingNrArr[index]];
            }

            temp.splice(index, 1);

            if (temp.length == 0 && this.interval) {
                this.setState({loading: false,processRunning:false,trackingNrQueueArr:[] })
                clearInterval(this.interval);
                this.interval = null;
            }
            this.setState({trackingNrArr: temp, trackObjects: tempTrackObj,trackingNrQueueArr:tempQueue})
            window.history.replaceState(null, "Tracefully", "/?tn=" + newArr.join(','))
        }
    }

    removeAll() {
        window.history.replaceState(null, "Tracefully", "/")
        this.setState({loading: false,processRunning:false,trackingNrArr: [], trackObjects: {}, trackingNrQueueArr:[]})
        this.ignoreUpdates = true;
    }


    buildTrackArr() {
        let TrackArrElems = [];
        if(this.state.loading){
            for(let i=0; i< this.state.trackingNrArr.length;i++){
                TrackArrElems.push(
                    <LoadingItem
                        id={this.state.trackingNrArr[i]}
                        key={this.state.trackingNrArr[i]}
                        trackingNr={this.state.trackingNrArr[i]}
                    />)
            }

        }else{

            let trackObjectKeys = Object.keys(this.state.trackObjects);
            let forceExpanded = false;
            if (trackObjectKeys.length == 1) {
                forceExpanded = true;
            }
            for (let i = 0; i < trackObjectKeys.length; i++) {
                TrackArrElems.push(
                    <TrackItem
                        id={trackObjectKeys[i]}
                        key={trackObjectKeys[i]}
                        item={this.state.trackObjects[trackObjectKeys[i]]}
                        expanded={false}
                        forceExpanded={forceExpanded}
                    />)
            }
            return TrackArrElems
        }


    }



    render() {
        const trackArr = this.buildTrackArr();
        let ContainerStyle='wide'
        let showAds=false
        if(this.state.trackingNrArr.length > 0){
            ContainerStyle='small'
            showAds=true;
        }
        return (
            <React.Fragment>

                <HeaderLayout className="nav-bar-top">
                    <HeaderTop didScroll={this.state.scroll}/>
                </HeaderLayout>


                <div className="MainContainer " style={{
                    backgroundImage: 'url("/resources/image/UI/dot_bkg.png")'
                }}>


                    {this.state.trackingNrArr.length > 0 && (

                        isMobile ? (
                            <div className={`TrackitemContainer mobileScroll`}  ref={this._scrollBarRef} onScroll={() => this.handleMobileScroll()}>
                                <div key="spacer" className="TrackItemTopSpacer"/>
                                <LoadingItem
                                    id={1}
                                    key={1}
                                    trackingNr={'test'}
                                />
                                {trackArr}
                                <div key="bottom spacer" className="TrackItemBottomSpacer"/>
                            </div>

                        ) : (
                            <div className="TrackitemContainer">
                                <PerfectScrollbar
                                    onScrollY={() => this.handleScroll()}
                                    ref={this._scrollBarRef}
                                    key="psb1"
                                    options={{
                                        wheelPropagation: true,

                                    }}>
                                    <div key="spacer" className="TrackItemTopSpacer"/>
                                    {trackArr}

                                </PerfectScrollbar>
                            </div>
                        )

                    )}



                    {this.props.AppSettings.viewportWidth > 1040 ? (



                            <div className={`NumberContainer ${ContainerStyle}`}>
                                <div className={`NumberContainerCard ${ContainerStyle}`}>
                                    <NumberBox
                                        loading={this.state.processRunning}
                                        onRemove={(index) => this.removeTnr(index)}
                                        onRemoveAll={(index) => this.removeAll(index)}
                                        onTrack={() => this.newTrack()}/>
                                </div>

                                {showAds && (
                                    <div className={'AdContainerCard'}>
                                        <AdSense.Google
                                            client='ca-pub-9104487371554868'
                                            slot='8005558898'
                                            style={{ display: 'block' }}
                                            format='auto'
                                            responsive='true'
                                            layoutKey='-gw-1+2a-9x+5c'
                                        />


                                    </div>
                                )}
                            </div>
                        ) :

                        <TrackIcon
                            canHide={this.props.AppSettings.trackingNrArr.length>0 &&
                            this.props.AppSettings.trackingNrArr[0].tnr!=""}
                            loading={this.state.processRunning}
                            onRemove={(index) => this.removeTnr(index)}
                                   onRemoveAll={(index) => this.removeAll(index)}
                                   onTrack={() => this.newTrack()}/>
                    }


                    <TranslationSelectorDialog/>

                    </div>


            </React.Fragment>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(index);


/*

ADS INFLOW

NOT SURE WHERE TO PUT THIS ON THE PAGE

                                    <div className={'inFlowAd'}>
                                        <div className={'inFlowAdContainer'}>
                                            <AdSense.Google
                                                client='ca-pub-9104487371554868'
                                                slot='6034001674'
                                                style={{ display:'inline-block',width:'728px',height:'90px' }}
                                                format=''
                                            />
                                        </div>
                                    </div>
 */

